<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import CompanyDropdown from "../../components/Business/CompanyDropdown.svelte";
  import OwnershipDropdown from "../../components/Business/OwnershipDropdown.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import DateInput from "../../components/Form/Fields/DateInput.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import Button from "../../components/Button.svelte";
  import Icon from "../../components/Icon.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { companyInvoiceEmailsDtoFields } from "../../utils/TableFields/company-invoice-emails-dto.fields";
  import {
    filter,
    loading,
    records,
    pagination,
    initList,
    onPageChange,
    search,
    clearSearch,
    exportInvoicePdf,
    sendEmail
  } from "./invoicesemails.store";
import type { ICompanyInvoiceEmailDTO } from "../../services/DTO";
import Input from "../../components/Form/Fields/Input.svelte";
import { PermissionService } from "../../utils/misc/permission-utils";
  import { user } from "../../app.store";

  $: tableFields = [...companyInvoiceEmailsDtoFields];

  let cansend : boolean = PermissionService.isAllowedTo($user, 'companyinvoices.cansend');
  

  function onSendemail(item: ICompanyInvoiceEmailDTO) {
      sendEmail(item.invoice.oid, item.invoice.companyId);
      search();
    }

  function onDownload(item: ICompanyInvoiceEmailDTO) {
    if (item.invoice.urlPdf != null && item.invoice.urlPdf != "")
      exportInvoicePdf(item.invoice.oid);
  }

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="fattura inviata"
    entityPlural="fatture inviate"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    searchFieldVisible={false}
    on:search={search}
  >
  <div slot="search" class="level">
    <div class="level-item" >
      <div>
        <FormField>
          <DateInput
            name=""
            placeholder="Data Inizio"
            required={false}
            bind:value={$filter.criteria.dataFrom}
              on:dateChanged={search}
          />
        </FormField>
        <FormField>
          <CompanyDropdown
            name=""
            placeholder="Filtra per cliente..."
            required={false}
            bind:value={$filter.criteria.companyid}
            on:select={search}
          />
        </FormField>
      </div>
    </div>


    <div class="level-item" >
      <div>
        <FormField>
          <DateInput
            name=""
            placeholder="Data Fine"
            required={false}
            bind:value={$filter.criteria.dataTo}
              on:dateChanged={search}
          />
        </FormField>
        <FormField>
          <OwnershipDropdown
            name=""
            placeholder="Filtra per az. proprietaria..."
            required={false}
            bind:value={$filter.criteria.ownershipid}
            on:select={search}
          />
        </FormField>
      </div>
    </div>
    <div class="level-item" >
      <div>
        <FormField usageHelp="Visualizza solo invii falliti">
          <Switch
            name=""
            condensed={true}
            altText="Solo invii falliti"
            bind:value={$filter.criteria.falliti}
            on:toggle={search}
          />
        </FormField>
      </div>
    </div>

    <div class="level-item">
      <div>
        <FormField  >
          <Input
            placeholder ="Diag. errore"
            required={false} 
            bind:value={$filter.criteria.diagnostico}
            on:enter={search}
          />
        </FormField>

      </div>
    </div>

    <div class="level-item">
      <div>


      </div>
    </div>

    <div class="level-item">
      <p class="control">
        <Button on:click={search}>
          <Icon name="search" />

          <span> Cerca </span>
        </Button>
      </p>
    </div>

    <div class="level-item">
      <p class="control">
        <Button on:click={clearSearch}>Azzera</Button>
      </p>
    </div>
  </div>

  </SearchHeader>

  <Table
    loading={$loading}
    fields={tableFields}
    records={$records}
    pagination={$pagination}
    createEnabled={false}
    editEnabled={false}
    deleteEnabled={false}
    downloadEnabled={true}
    customEnabled={cansend}
    customIcon="send"
    on:custom={(e) => onSendemail(e.detail)}
    on:download={(e) => onDownload(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
